// Utils
import { getEnvironmentApiUrl } from "../../../services/General";

// Hooks
import useHttp from "../../../hooks/useHttp";

// Models
import { Role, UserData } from "../../../interfaces/UserInfo";

const useFormEditUser = (user: UserData, roles: Role[], updateUser: (user: UserData) => void) => {

    const { sendRequest: modifyUser } = useHttp();
    const { sendRequest: assignUserRole } = useHttp();

    const defaultRoleIDs = user.user_roles?.map(r => r.role_id);

    const addUserToState = (
        roleIDs: number[],
        changedUserData: Pick<UserData, 'active' | 'email' | 'is_reference_doctor' | 'reference_doctor_id'>
    ) => {

        const userRoles = roleIDs.map(id => {
            const role = roles.find(r => r.id === id);
            if (!role) return null;
            return {
                user_id: user.id,
                role_id: role.id,
                role
            }
        }).filter(r => r !== null) as UserData['user_roles'];

        const newUserData: UserData = {
            ...user,
            ...changedUserData,
            user_roles: userRoles
        };

        updateUser(newUserData);

    };

    const onConfirm = (
        roleIDs: number[],
        activeUser: boolean,
        email: string,
        isReferenceDoctor: boolean,
        referenceDoctorId: number | null
    ) => {

        const newUser = {
            active: activeUser,
            email: email,
            is_reference_doctor: isReferenceDoctor,
            reference_doctor_id: isReferenceDoctor ? null : referenceDoctorId,
        };

        modifyUser({
            url: getEnvironmentApiUrl() + 'user/' + user.id,
            method: 'PUT',
            body: newUser,
        }, () => {
            let index = 0;
            const rolesToAssign = roleIDs.filter(id => !defaultRoleIDs.includes(id));
            const rolesToUnassign = defaultRoleIDs.filter(id => !roleIDs.includes(id));

            const callback = () => {
                index++;
                if (index < rolesToAssign.length + rolesToUnassign.length) return;
                addUserToState(roleIDs, newUser);
            }

            callback();

            for (const roleID of rolesToAssign) {
                assignUserRole({
                    url: getEnvironmentApiUrl() + 'user/assign_role',
                    method: 'POST',
                    body: { role_id: roleID, user_id: user.id }
                }, callback);
            }
            for (const roleID of rolesToUnassign) {
                assignUserRole({
                    url: getEnvironmentApiUrl() + 'user/unassign_role',
                    method: 'POST',
                    body: { role_id: roleID, user_id: user.id }
                }, callback);
            }

        });

    };

    return { onConfirm }


}

export default useFormEditUser;